import React, { FC, ReactNode } from 'react';

import { Box, Stack } from '@chakra-ui/react';
import { customTheme } from 'theme';

interface DetailsSectionProps {
  title: ReactNode;
  children: ReactNode;
}

/** One titled block of a table's details. */
export const DetailsSection: FC<DetailsSectionProps> = ({
  title,
  children,
}) => (
  <Stack spacing={1} minW={0}>
    <Box
      fontSize="13px"
      color={customTheme.colors.gray['300']}
      letterSpacing="wide"
    >
      {title}
    </Box>
    <Box fontSize="sm" whiteSpace="normal" wordBreak="break-word">
      {children}
    </Box>
  </Stack>
);
